import styled from 'styled-components';

export const PageHead = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 800px){
    flex-direction: ${props => props.open ? "row" : "column"};
  }
  a {
    margin-top: 10px;
  }
  h2 {
    max-width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    @media (max-width: 992px){
      font-size: 20px;
    }
    @media (max-width: 768px){
      font-size: 18px;
      padding-bottom: 5px;
    }
    @media (max-width: 480px){
      font-size: 15px;
    }
  }
`;

export const MenuLeftAdmin = styled.ul`
  display: flex;

  li:not(:first-child) a {
   @media (max-width: 990px){
     display: none;
  }
}

img {
  max-width: 30px;
}
`;

export const HeaderWrap = styled.div`
  position: fixed;
  left: 0;
  z-index: 500;
  width: 100%;
  margin: 0;
  background-color: #edbd2f;
`;

export const Menu = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;


export const HeaderWrapper = styled.div`
  display: flex;
  min-height: 50px;
  background-color: #edbd2f;

`;

export const HeaderLeft = styled.div`
  width: 100px;
  text-align: center;
  background-color: #edbd2f;
  padding: 14px 0;

  img {
    max-width: 25px;
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;

  a {
  display: block;
  padding: 28px 19px;
  transition: all .3s linear;

  &:hover {
    color: #fff;
    background-color: #da9c15;
  }
}
`;

export const Toggle = styled.div`
  padding: 9px 15px;
  height: 100%;
  cursor: pointer;
  display: flex;
  @-moz-document url-prefix() {
  &{
      padding: 20px 15px;
  }

  &:hover {
    background-color: #edbd2f;
  }

  img {
    width: 25px;

  }
`;

export const MenuRightAdmin = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: 50px;
  background-color: #554f4d;
  color: #fff;
  @media (max-width: 990px){
    display: none;
  }
  div {
  align-items: center;
  padding: 26px 9px;
  transition: all .3s linear;
  cursor: pointer;
  &:hover {
    color: #fff;
    background-color: #da9c15;
  }
  a {
    color: #fff;
  }
  span {
    color: #fff;
    padding-left: 5px;
  }
  &:first-child {
    border-right: 1px solid #fff;
  }
}
`;


export const Toggler = styled.div`

  i {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000;
    width: 50px;
    height: 50px;
    font-size: 30px;
    cursor: pointer;
    border: 1px solid #000;
    border-radius: 50%;

    &:hover {
      border-color: #554f4d;
      color: #554f4d;
      transition: all .3s linear;
    }
  }
`;

export const DropdownMenuWrapper = styled.div`
  position: relative;
  margin-right: 20px;
`

export const DropdownMenu = styled.ul`
  visibility: ${props => props.visible ? "visible" : "hidden"};
  transition: opacity .5s,transform .5s;
  transition: opacity .5s,transform .5s,-webkit-transform .5s;
  transition-timing-function: cubic-bezier(.2,1,.3,1);
  transform: scale3d(1,1,1) translate3d(0,0,0);
  opacity: ${props => props.visible ? "1" : "0"};
  position: absolute;
  background-color: #fff;
  border-radius: 4px;
  min-width: 200px;
  right: 0;
  left: auto;
  top: 55px;
  padding: 15px 25px;

  a {
    transition: all .25s linear;
    &:hover {
      color: #edbd2f;
    }
  }

  li {
    padding: 12px 0;

    &:first-child {
      font-size: 17px;
      border-bottom: 1px solid #b3b3b3;
      font-weight: bold;

      div {
        font-size: 13px;
        margin-top: 8px;
        font-weight: 300;
      }
    }

    &:last-child {
      border-top: 1px solid #b3b3b3;
    }
  }
`

export const MenuLeft = styled.ul`
  display: flex;

  li:not(:first-child) a {
    @media (max-width: 990px){
      display: none;
    }
  }
  li:nth-child(2) i{
    position: absolute;
    top: 50%;
    left: 100px;
    transform: translateY(-50%);

    @media screen and (min-width: 768px) {
      position: relative;
      margin-left: 15px;
      top: auto;
      left: auto;
      transform: none;
    }
  }

  a {
    display: block;
    padding: 26px 19px;
    transition: all .3s linear;

    &:hover {
      color: #fff;
      background-color: #da9c15;
    }
  }

  img {
    max-width: 30px;
  }
`

export const Logo = styled.li`
  a {
    padding: 10px 15px 0;

    &:hover {
      background-color: transparent;
    }
    @media (max-width: 992px) {
      display: block;
      margin-left: 10px;
    }
    @media (min-width: 768px) {
      width: 100%;
    }
  }
  img {
    margin-bottom: 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/header/components.js